exports = module.exports = require("../../../../node_modules/@angular/cli/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".formxon{\n    font-size: 0.8rem;\n    color: gray;\n}\n.imgProduct{\n    width: 70px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/components/detail-order/detail-order.component.css
// module id = ../../../../../src/app/components/detail-order/detail-order.component.css
// module chunks = main